module.exports = " <div class=ui> <div class=navbar-wrapper> <div class=navbar> <div class=left> </div> <div class=title>PACO-UI</div> <div class=right></div> </div> </div> <span class=agree-it><paco-check value=on>同意</paco-check><a href=http://hcz.pingan.com/common/page/provision/loss.html>《平安好车主服务协议》</a></span> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/AgreemeView.vue
// module id = 142
// module chunks = 1